import { render, staticRenderFns } from "./WorkingAreaQuickView.vue?vue&type=template&id=e0197620&scoped=true"
import script from "./WorkingAreaQuickView.vue?vue&type=script&lang=js"
export * from "./WorkingAreaQuickView.vue?vue&type=script&lang=js"
import style0 from "./WorkingAreaQuickView.vue?vue&type=style&index=0&id=e0197620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0197620",
  null
  
)

export default component.exports